import Vue from 'vue'
import VueRouter from 'vue-router'
import Welcome from '../views/Welcome.vue'
import Follow from '../views/Follow'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'welcome',
    component: Welcome
  },
  {
    path: '/project/:prjId',
    name: 'prjId-welcome',
    component: Welcome
  },
  {
    path: '/project/:prjId/qrcode/:qrCode',
    name: 'prjId-qrCode-welcome',
    component: Welcome
  },
  {
    path: '/project/:prjId/follow/:guideId?',
    name: 'follow',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Follow
  },
  {
    path: '/reg-1',
    name: 'reg-1',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Reg-1.vue')
  },
  {
    path: '/reg-2',
    name: 'reg-2',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Reg-2.vue')
  },
  {
    path: '/reg-3',
    name: 'reg-3',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Reg-3.vue')
  },
  {
    path: '/reg-4',
    name: 'reg-4',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Reg-4.vue')
  },
  {
    path: '/exhibition',
    name: 'exhibition',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Exhibition.vue')
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import(/* webpackChunkName: "about" */ '../views/Callback.vue')
  },
  {
    path: '/liveVideoLogin',
    name: 'liveLogin',
    component: () => import(/* webpackChunkName: "about" */ '../views/LiveLogin.vue')
  },
  {
    path: '/LiveVideoStream',
    name: 'liveVideoStream',
    component: () => import(/* webpackChunkName: "about" */ '../views/LiveVideoStream.vue')
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "about" */ '../views/PageNotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
